import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';

import { ModalMessageDialogComponent } from './modal-message-dialog.component';
import { ModalInputDialogComponent, DialogResponseInput } from './modal-input-dialog.component';
import { ModalConfirmDialogComponent } from './modal-confirm-dialog.component';
import { ModalChecklistDialogComponent } from './modal-checklist-dialog.component';
import { ModalLinkConfirmacionComponent } from './link-confirmacion/modal-link-confirmacion.component';
import { MotivosRechazo } from '../../cliente/motivosRechazo/motivosRechazo.model';
import { ModalImageDialogComponent } from './modal-image-dialog.component';
import { ModalImageSliderDialogComponent } from './modal-image-slider-dialog.component';
import { ModalModificacionCostosEnvioMasivoComponent } from './modificacion-costos-envio/modal-modificacion-costos-envio-masivo/modal-modificacion-costos-envio-masivo.component';

@Injectable()
export class DialogService {
  constructor(private dialog: MatDialog) { }

  public confirm(title: string, firstMessage?: string, msgList?: string[]): Promise<boolean> {
    let dialogRef: MatDialogRef<ModalConfirmDialogComponent>;

    dialogRef = this.dialog.open(ModalConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.msgList = msgList;

    return dialogRef.afterClosed().toPromise();
  }

  public confirmYesNo(title: string, firstMessage?: string, msgList?: string[]): Promise<boolean> {
    let dialogRef: MatDialogRef<ModalConfirmDialogComponent>;

    dialogRef = this.dialog.open(ModalConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.msgList = msgList;
    dialogRef.componentInstance.okButtonText = 'SI';
    dialogRef.componentInstance.cancelButtonText = 'NO';


    return dialogRef.afterClosed().toPromise();
  }

  public alert(title: string, firstMessage?: string, msgList?: string[]) {
    let dialogRef: MatDialogRef<ModalMessageDialogComponent>;

    dialogRef = this.dialog.open(ModalMessageDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.msgList = msgList;

    return dialogRef.afterClosed().toPromise();
  }

  confirmWithInput(title: string, placeholder: string): Promise<DialogResponseInput> {
    let dialogRef: MatDialogRef<ModalInputDialogComponent>;

    dialogRef = this.dialog.open(ModalInputDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.placeholder = placeholder;
    dialogRef.componentInstance.comment = '';

    return dialogRef.afterClosed().toPromise();
  }

  public rechazar(title: string, firstMessage?: string, checklist?: MotivosRechazo[]): Promise<any> {
    let dialogRef: MatDialogRef<ModalChecklistDialogComponent>;

    dialogRef = this.dialog.open(ModalChecklistDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.checklist = checklist;

    return dialogRef.afterClosed().toPromise();
  }

  public getLinkReenvio(link: string): Promise<any> {
    let dialogRef: MatDialogRef<ModalLinkConfirmacionComponent>;

    dialogRef = this.dialog.open(ModalLinkConfirmacionComponent);
    dialogRef.componentInstance.link = link;

    return dialogRef.afterClosed().toPromise();
  }

  public imageViewer(title: string, firstMessage?: string, imgSrc?: any): Promise<boolean> {
    let dialogRef: MatDialogRef<ModalImageDialogComponent>;

    dialogRef = this.dialog.open(ModalImageDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.imgSrc = imgSrc;

    return dialogRef.afterClosed().toPromise();
  }


  public imagesSliderViewer(title: string, firstMessage?: string, images?: any): Promise<boolean> {
    let dialogRef: MatDialogRef<ModalImageSliderDialogComponent>;

    dialogRef = this.dialog.open(ModalImageSliderDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.firstMessage = firstMessage;
    dialogRef.componentInstance.images = images;

    return dialogRef.afterClosed().toPromise();
  }

  public modificacionPreciosCostoEnvio(): Promise<boolean> {
    let dialogRef: MatDialogRef<ModalModificacionCostosEnvioMasivoComponent>;

    dialogRef = this.dialog.open(ModalModificacionCostosEnvioMasivoComponent);
    
    return dialogRef.afterClosed().toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/dialog.service.ts